import translator from "@/translator";
import React, { useState, useEffect } from "react";
import { Form, Spin } from "antd";
import BackButton from "@/note_office/shared/BackButton";
import ServiceForm from "./components/ServiceForm";
import useServiceSubmit from "@/note_office/views/services/hooks/useServiceSubmit";

const t = translator("note_office.views.services.edit_view.");

const EditView = ({ servicesData }) => {
  const { services_url, update_service_url, duration_options, currency_options, format_options } =
    servicesData || {};
  const {
    name: initialName,
    duration: initialDuration,
    price_min: initialPriceMin,
    price_max: initialPriceMax,
    description: initialDescription,
    active: initialActive,
    currency: initialCurrency,
    format: initialFormat,
    meeting_url: initialMeetingUrl,
    address: initialAddress,
  } = servicesData.service || {};

  const [loading, setLoading] = useState(true);
  const [form] = Form.useForm();
  const isCustomCurrency = !currency_options.some((opt) => opt.value === initialCurrency);

  const { isSubmitting, submitService } = useServiceSubmit({
    form,
    url: update_service_url,
    method: "put",
    t,
    onSuccessRedirect: (data) => data.redirect_path,
  });

  useEffect(() => {
    if (servicesData) {
      form.setFieldsValue({
        name: initialName,
        duration: initialDuration,
        price_min: initialPriceMin,
        price_max: initialPriceMax,
        description: initialDescription,
        active: initialActive,
        currency: isCustomCurrency ? "other" : initialCurrency,
        custom_currency: isCustomCurrency ? initialCurrency : undefined,
        format: initialFormat,
        meeting_url: initialMeetingUrl,
        address: initialAddress,
      });
    }
    setLoading(false);
  }, [servicesData]);

  const handleFinish = (values) => submitService(values);

  const handleCancel = () => {
    window.location.href = services_url;
  };

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      {loading ? (
        <Spin size="large" className="loader" />
      ) : (
        <>
          <BackButton link={services_url} text={t("title")} />

          <ServiceForm
            form={form}
            loading={isSubmitting}
            onFinish={handleFinish}
            duration_options={duration_options}
            currency_options={currency_options}
            format_options={format_options}
            onCancel={handleCancel}
          />
        </>
      )}
    </div>
  );
};

export default EditView;
